import React from "react";

export default function PublicProjectsFeedback({ loading, error, retry, empty }) {
  if (loading) return <p role="status">Loading projects…</p>;
  if (error) return <div role="alert"><p>{error}</p><button type="button" className="public-projects-load-more" onClick={retry}>Try again</button></div>;
  if (empty) return <p role="status">No published projects yet.</p>;
  return null;
}
